import "core-js/modules/es6.object.define-property";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from 'styled-components';
export var DropdownContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n    border-radius: ", ";\n    box-shadow: ", ";\n    overflow: auto;\n    position: absolute;\n    max-height: ", ";\n    margin-top: ", ";\n    ", "\n    z-index: ", ";\n    width: ", ";\n"], ["\n    background-color: ", ";\n    border-radius: ", ";\n    box-shadow: ", ";\n    overflow: auto;\n    position: absolute;\n    max-height: ", ";\n    margin-top: ", ";\n    ", "\n    z-index: ", ";\n    width: ", ";\n"])), function (props) {
  return props.theme.colors.light;
}, function (props) {
  return props.theme.cornerRadii["default"];
}, function (props) {
  return props.theme.shadows.box.spread;
}, function (props) {
  return typeof props.maxHeight === 'number' ? props.theme.units.getValue(props.maxHeight) : props.maxHeight;
}, function (props) {
  return props.theme.units.getValue(1);
}, function (props) {
  return props.rightAlign && 'right: 0;';
}, function (props) {
  return props.theme.zIndex.Z_INDEX_9;
}, function (props) {
  return typeof props.width === 'number' ? props.theme.units.getValue(props.width) : props.width;
});
var templateObject_1;